export default __webpack_public_path__ + "static/media/amparo-site.75b2913b.webp";